import { useEffect, useState } from "react";
import "./ServidorShop.css";

const Vehiculos = () => {
  const [vehiculos, setVehiculos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetch("/api/tienda-servidor/vehiculos")
      .then((res) => res.json())
      .then((data) => {
        setVehiculos(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        console.error("Error cargando vehículos:", error);
        setVehiculos([]);
      })
      .finally(() => {
        setCargando(false);
      });
  }, []);

  if (cargando) {
    return <p className="shop-loading">Cargando vehículos...</p>;
  }

  return (
    <main className="shop-page">
      <section className="shop-hero">
        <span>🚗 TIENDA DEL SERVIDOR</span>
        <h1>Vehículos disponibles</h1>
        <p>Consulta los precios oficiales de los vehículos dentro del servidor.</p>
      </section>

      <section className="shop-table-card">
        <div className="shop-table-header">
          <h2>Lista de Vehículos</h2>
          <p>{vehiculos.length} vehículos encontrados</p>
        </div>

        <table className="shop-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Vehículo</th>
              <th>Precio</th>
            </tr>
          </thead>

          <tbody>
            {vehiculos.length === 0 ? (
              <tr>
                <td colSpan="3">No hay vehículos disponibles.</td>
              </tr>
            ) : (
              vehiculos.map((vehiculo, index) => (
                <tr key={vehiculo.id}>
                  <td>#{index + 1}</td>
                  <td>{vehiculo.vehicleName}</td>
                  <td>${Number(vehiculo.cost).toFixed(2)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </section>
    </main>
  );
};

export default Vehiculos;